var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 195 Q168 118 200 105 Q232 118 232 195 Q200 208 168 195 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 168 Q200 176 208 168",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155 130 Q120 100 90 115 Q70 90 50 105",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245 130 Q280 100 310 115 Q330 90 350 105",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175 105 Q160 70 140 55 Q120 40 100 50",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225 105 Q240 70 260 55 Q280 40 300 50",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200 100 Q200 70 185 45 Q175 30 180 20",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160 140 Q130 140 110 155 Q90 165 70 160",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M240 140 Q270 140 290 155 Q310 165 330 160",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80 Q65 75 70 80 Q75 75 80 80",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M320 70 Q325 65 330 70 Q335 65 340 70",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85 180 Q90 175 95 180",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305 180 Q310 175 315 180",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 130,
    r: 2,
    fill: "#38bdf8",
    opacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 130,
    r: 2,
    fill: "#fbbf24",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 45,
    r: 1.5,
    fill: "#fafcfb",
    opacity: 0.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 45,
    r: 1.5,
    fill: "#fafcfb",
    opacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 170,
    r: 1,
    fill: "#fbbf24",
    opacity: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 170,
    r: 1,
    fill: "#38bdf8",
    opacity: 0.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 60,
    r: 2,
    fill: "#38bdf8",
    opacity: 0.4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 60,
    r: 2,
    fill: "#fbbf24",
    opacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 220,
    rx: 80,
    ry: 15,
    stroke: "#38bdf8",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.c895636feb10d16881573ae00b7ca180.svg";
export { ForwardRef as ReactComponent };